module.exports = __webpack_public_path__ + "static/media/ayala-malls-logo.840dd606.svg";